import { Record, RecordOf } from 'immutable';



export type RedirectionState = RecordOf<RedirectionStateProperties>;


export interface RedirectionStateProperties {
  businessUrl: string;
  redirectionUrl: string;
  registrationUrl: string;
  sourceUrl: string;
  targetUrl: string;
}


export class RedirectionStateFactory {

  static readonly create = Record<RedirectionStateProperties>({
    businessUrl: null,
    redirectionUrl: null,
    registrationUrl: null,
    sourceUrl: null,
    targetUrl: null
  });

  static getInitialState(): RedirectionState {
    const config = window['__CPC__']()['urls'];
    return RedirectionStateFactory.create({
      businessUrl: config.businessUrl || '',
      redirectionUrl: config.redirectionUrl || '',
      registrationUrl: config.registrationUrl || '',
      sourceUrl: config.sourceUrl || '',
      targetUrl: config.targetUrl || ''
    });
  }

}
